import { getSelectedPlatform } from "../../utils/checkPlatform";
import axios from "axios";
export default {
  namespaced: true,
  state: {
    selectedPlatform: getSelectedPlatform(),
    local: null,
    platformId: 30,
    currentDomain: null,
    currentPath: null,
  },
  getters: {
    getPlatformId: (state) => state.platformId,
    getSelectedPlatform: (state) => state.selectedPlatform,
  },
  mutations: {
    setselectedPlatform(state, payload) {
      state.selectedPlatform = payload;
      localStorage.setItem("selectedPlatform", payload);
    },
    setCurrentDomain(state, payload) {
      state.currentDomain = payload;
    },
    setCurrentPath(state, payload) {
      state.currentPath = payload;
    },
    setPlatform(state, payload) {
      state.platformId = payload;
    },
  },
  actions: {
    async checkPlatform({ commit, state }, payload) {
      var { currentDomain, currentPath } = payload;
      if (state.selectedPlatform) {
        currentDomain = state.selectedPlatform;
      }

      commit("setCurrentDomain", currentDomain);
      commit("setCurrentPath", currentPath);

      await axios
        .post(
          "https://dev-api.d7ksuper.com/api/v1/Account/GetPlatformKey?platform=" +
            currentDomain
        )
        .then((response) => {
          commit("setPlatform", response.data.data);
        })
        .catch((error) => {
          console.log("Platform hatalı");
          // console.error("There was an error!", error);
        });
    },
  },
};
